import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { MenuItem, MenuLateralComponent, ToastService } from 'govbr-lib';
import { UsuarioService } from 'src/app/components/usuario/service/usuario.service';
import { UsuarioDTO } from 'src/app/models/UsuarioDTO';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SigaService } from 'src/app/services/siga.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'gov-cabecalho-plataforma',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss'],
})
export class CabecalhoComponent implements OnChanges {

  @Input() usuario: UsuarioDTO;
  @Input() itemsMenu: MenuItem[];

  isOpen: boolean;
  fotoPerfil: string;
  timestamp = new Date().getTime();

  constructor(
    public dialog: MatDialog,
    private toastService: ToastService,
    private router: Router,
    private usuarioService: UsuarioService,
    private sigaService: SigaService,
    private analytics: GoogleAnalyticsService
  ) { }

  ngOnChanges(): void {
    this.buscarUsuario(this.usuario.id.toString());
  }

  navOpen($event): void {

    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      const dialog = this.dialog.open(MenuLateralComponent, {
        data: this.itemsMenu,
        width: '100vw',
        height: 'calc(100vh - 80px)',
        panelClass: 'govbr-menu-lateral',
        maxWidth: '100vw',
        position: { top: '80px' },
        backdropClass: 'govbr-menu-lateral-backdrop',
      });

      dialog.componentInstance.funcionalidade.subscribe(func => {
        if (func.nome == 'Suporte') {
          this.sigaService.getTokenSigaSolicitante(this.usuario.id).subscribe((response: any) => {
            const url = environment.urlSigaSolicitante + response.token;
            window.open(url, '_blank');
          });
          this.analytics.emitirEvento('S4_redirecionar_acesso_siga_menu_lateral', 'menu', 'menu_suporte');
        }
      })

      this.isOpen = !this.isOpen;
    } else {
      this.dialog.closeAll();
    }
  }

  irParaTelaUsuario() {
    this.router.navigate([`/usuarios/atualizar/${this.usuario.id}`]);
  }

  buscarUsuario(id: string) {
    const usuarioId = Number(id);
    this.usuarioService.buscarUsuarioBack(usuarioId).subscribe(
      (usuario: UsuarioDTO) => {
        this.fotoPerfil = usuario.fotoPerfil;
        // força o navegador a buscar a nova imagem com a mesma url
        this.timestamp = new Date().getTime();
      },
      (erro) => {
        this.toastService.show(
          {
            type: 'warning',
            text: 'Erro ao buscar usuário: ' + erro
          }
        );
      }
    );
  }

  sair() {
    this.usuarioService.logout();

    this.router.navigate(['/login']);
    this.toastService.show({
      type: 'info',
      text: 'Logout realizado com sucesso!',
    });
  }

}
